"use client";

import React, { type ReactElement, useEffect } from "react";
import {
  DevicesSidebar,
  DevicesDeviceList,
  GlobalPageHeader,
  DevicesDrawer,
} from "@/components";
import { useSearchParams } from "next/navigation";
import { useSetAtom } from "jotai";
import { selectedTagIdsAtom } from "@/store/devices";
import { getApplication } from "@/services/applications";
import { useLocale } from "next-intl";
import { useIsMobile } from "@oreme/ui";

function DevicesMain(): ReactElement {
  const application = getApplication("devices");
  const locale = useLocale();
  const isMobile = useIsMobile();

  const setSelectedTagIds = useSetAtom(selectedTagIdsAtom);
  const searchParams = useSearchParams();
  const tagParam = searchParams.get("tag");

  useEffect(() => {
    if (tagParam) {
      setSelectedTagIds([Number(tagParam)]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex-1">
      <GlobalPageHeader
        title={application!.title[locale]}
        lead={application!.lead[locale]}
      />
      <div className="relative max-w-7xl mx-auto px-4 grid grid-cols-12">
        <aside className="relative hidden md:block md:col-span-4 lg:col-span-3 border-r">
          <DevicesSidebar />
        </aside>
        <div className="col-span-12 md:col-span-8 lg:col-span-9">
          {isMobile ? (
            <header className="flex justify-end items-center gap-4 px-4 py-2.5 -mx-4 border-b leading-none">
              <DevicesDrawer />
            </header>
          ) : null}
          <DevicesDeviceList />
        </div>
      </div>
    </div>
  );
}

export { DevicesMain };
